import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from "react-icons/rx";
import { IoAddSharp } from "react-icons/io5";
import { useCurrency } from '../../Layouts/currencyContext';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';

const DirectPurchaseUpGrid = ({ onRequisitionData, itemData, selectedCheck, currencyPrecision }) => {
    const rows = useSelector(state => state.rows.rows);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [vat, setvat] = useState([]);
    const apiService = new ApiService();
    const dispatch = useDispatch();
    const [itemRows, setItemRows] = useState([]);
    const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    useEffect(() => {
        getVat();
        if (itemData) {
            getItemsUpdate();
        }
    }, [itemData]);
    useEffect(() => {
        if (rows[0]?.ItemNo) {
            updatevat();
        }
    }, [selectedCheck]);
    const getVat = async () => {
        let vatParam = `?toPurchase=true`
        const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
        setvat(vat.data.result)
    }
    const getItemsUpdate = async () => {
        try {
            if (itemData?.grnDetails) {
                const formattedRowsitm = itemData?.grnDetails.map(async (detail, index) => {
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    const getunit = await apiService.getApiParamater("GET_ITEM_PACK", `?ItemNo=${detail.itemCode}`);
                    let glAccount = getGLAccounts?.data?.result[0]
                    let selecteditem = getunit?.data?.result[0]
                    let amount = detail.qty * detail.unitPrice

                    const perAmount = (amount / 100) * detail?.vatPerc
                    let ExcludedAmount = amount + perAmount
                    return {
                        requisitionNo: itemData.requisitionNo || "",
                        srno: detail.srno,
                        ItemNo: detail.itemCode,
                        recordId: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        qty: detail.qty,
                        uom: detail.uom,
                        stock: selecteditem.convToInvUOM * detail.qty,
                        baseAmount: detail.unitPrice,
                        baseQty: selecteditem.convToInvUOM,
                        specification: detail.specification,
                        amount: selectedCheck === true ? ExcludedAmount : amount,
                        vat: detail?.vatPerc || 0,
                        vatDes: detail?.vatDesc,
                        expDate: detail.expDate,
                        batchNo: detail.batchNo,
                        vatAmount: perAmount,
                        inventoryAccountCode: glAccount?.inventoryAccountCode,
                        inventoryAccountName: glAccount?.inventoryAccountName,
                        GRNAccountName: glAccount?.grnAccountName,
                        GRNAccountCode: glAccount?.grnAccountCode,
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    dispatch(setRows(formattedRows));
                    setItemRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    useEffect(() => {
        fetchData();
        getVat()
    }, []);

    const updatevat = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const selectedVat = vat?.find(tax => tax.description === row?.vatDes);
                let amount = row.qty * row.baseAmount
                const perAmount = (amount / 100) * (selectedVat?.rate || 0)
                let excludedAmount = amount + perAmount
                const calculatedAmount = selectedCheck === true ? excludedAmount : amount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].amount = calculatedAmount;
                updatedRows[index].vatDes = selectedVat?.description;
                updatedRows[index].vat = selectedVat?.rate || 0;
                updatedRows[index].vatAmount = perAmount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].discount = row.discount || 0;
            });
            await Promise.all(apiPromises);
            setRows(updatedRows);
            onRequisitionData(updatedRows);
            dispatch(setRows(updatedRows));
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const fetchData = async () => {
        try {
            const response = await apiService.getApiParamater('GET_ITEM_PACK', '?isActive=true');
            const selecteditem = response.data.result?.filter(rec => rec.exp9 === '1')
            if (response?.data?.result?.length > 0) {
                setApiData(selecteditem);
                setItemOptions(selecteditem.map(item => ({
                    value: item.itemNo,
                    label: item.itemNo
                })));
                setDescriptionOptions(selecteditem.map(item => ({
                    value: item.itemDescription,
                    label: item.itemDescription
                })));
            } else {
                console.error('No data found in the API response');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleInputChange = async (index, fieldName, value) => {
        const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.ItemNo === value || row.itemDescription === value));
        if (isDuplicate) {
            toast.error('Please choose a different item.');
            return;
        }
        const updatedRows = rows.map(async (row, rowIndex) => {

            if (rowIndex === index) {
                const updatedRow = { ...row, [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };

                if (fieldName === 'ItemNo') {
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${value}`);
                    const getunit = await apiService.getApiParamater("GET_ITEM_PACK", `?ItemNo=${value}`);
                    let glAccount = getGLAccounts?.data?.result[0]
                    let unitprice = getunit?.data?.result[0]
                    const selectedItem = apiData?.find(item => item.itemNo === value);
                    const selectedVat = vat?.find(tax => tax?.description === selectedItem?.vat);
                    if (selectedItem) {
                        updatedRow.itemDescription = selectedItem.itemDescription;
                        updatedRow.ItemNo = selectedItem.itemNo;
                        updatedRow.requisitionNo = selectedItem.itemDescription;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.specification = selectedItem.specification;
                        updatedRow.vat = selectedVat?.rate || 0;
                        const quantity = parseFloat(updatedRow.qty);
                        const unitPrice = parseFloat(updatedRow.baseAmount);
                        let amount = quantity * unitPrice || 0
                        const perAmount = (amount / 100) * selectedVat?.rate || 0
                        updatedRow.vatAmount = perAmount;
                        updatedRow.vatDes = selectedVat?.description || "---";
                        updatedRow.baseAmount = unitprice?.avgPrice?.toFixed(currencyPrecision || 0) || 0;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        updatedRow.inventoryAccountCode = glAccount?.inventoryAccountCode;
                        updatedRow.inventoryAccountName = glAccount?.inventoryAccountName;
                        updatedRow.GRNAccountName = glAccount?.grnAccountName;
                        updatedRow.GRNAccountCode = glAccount?.grnAccountCode;
                    }
                } else if (fieldName === 'itemDescription') {
                    const selectedItem = apiData?.find(item => item.itemDescription === value);
                    const selectedVat = vat?.find(tax => tax?.description === selectedItem?.vat);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${selectedItem.itemNo}`);
                    const getunit = await apiService.getApiParamater("GET_ITEM_PACK", `?ItemNo=${selectedItem.itemNo}`);
                    let glAccount = getGLAccounts?.data?.result[0]
                    let unitprice = getunit?.data?.result[0]
                    if (selectedItem) {
                        updatedRow.specification = selectedItem.specification;
                        updatedRow.recordId = selectedItem.itemNo;
                        updatedRow.ItemNo = selectedItem.itemNo;
                        updatedRow.uom = selectedItem.baseUnit;
                        updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        updatedRow.vatDes = selectedVat?.description;
                        updatedRow.baseAmount = unitprice?.avgPrice?.toFixed(currencyPrecision || 0) || 0;
                        const quantity = parseFloat(updatedRow.qty);
                        const unitPrice = parseFloat(updatedRow.baseAmount);
                        let amount = quantity * unitPrice || 0
                        const perAmount = (amount / 100) * selectedVat?.rate || 0
                        updatedRow.vatAmount = perAmount;
                        updatedRow.vat = selectedVat?.rate || 0;
                        updatedRow.inventoryAccountCode = glAccount?.inventoryAccountCode;
                        updatedRow.inventoryAccountName = glAccount?.inventoryAccountName;
                        updatedRow.GRNAccountName = glAccount?.grnAccountName;
                        updatedRow.GRNAccountCode = glAccount?.grnAccountCode;
                    }
                }
                if (fieldName === 'qty') {

                    const quantity = parseFloat(value);
                    const selectedItem = apiData?.find(data => data?.itemDescription === row?.itemDescription);
                    const baseQty = selectedItem ? selectedItem.convToInvUOM : 1;
                    updatedRow.baseQty = parseFloat(baseQty);
                }
                if (fieldName === 'qty' || fieldName === 'baseAmount') {
                    const selectedItem = apiData?.find(data => data?.itemDescription === row?.itemDescription);
                    const slectedVat = updatedRow.vatDes;
                    const selectedVat = vat?.find(tax => tax?.description === slectedVat);
                    const quantity = parseFloat(updatedRow.qty);
                    const unitPrice = parseFloat(updatedRow.baseAmount);
                    let amount = quantity * unitPrice || 0
                    const perAmount = (amount / 100) * selectedVat?.rate
                    let ExcludedAmount = amount + perAmount
                    updatedRow.amount = selectedCheck ? ExcludedAmount : amount;
                    updatedRow.stock = updatedRow.baseQty * quantity || 0;
                    updatedRow.vatAmount = perAmount;
                }
                if (fieldName === 'vat') {
                    let amount = row.qty * row.baseAmount

                    const perAmount = (amount / 100) * (value?.rate || 0)
                    let excludedAmount = amount + perAmount
                    const calculatedAmount = selectedCheck === true ? excludedAmount : amount;
                    updatedRow.calculatedAmount = parseFloat(calculatedAmount);
                    updatedRow.amount = parseFloat(calculatedAmount);
                    updatedRow.vatDes = value?.description;
                    updatedRow.vat = parseFloat(value?.rate);
                    updatedRow.vatAmount = parseFloat(perAmount);
                }
                return updatedRow;
            }
            return row;
        }).filter(row => row !== null);
        const formattedRows = await Promise.all(updatedRows);
        setRows(formattedRows);
        dispatch(setRows(formattedRows));
        setItemRows(formattedRows);
        onRequisitionData(formattedRows);
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            ItemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            batchNo: ''
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));
        setRows(updatedRows);
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th></th>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>expDate</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Array.isArray(rows) && rows.map((row, index) => (
                            <tr key={index}>
                                {itemData?.requisitionNo ?
                                    <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                        <div className='center'> <RxCross1 size={15} /></div></td> :
                                    <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                        {itemData?.eye === true ?
                                            <div className='center'><RxCross1 size={15} /></div> :
                                            <div onClick={() => handleRemoveRow(index)} className='center'><RxCross1 size={15} /></div>
                                        }
                                    </td>
                                }
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.srno} disabled style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'>
                                    {itemData?.eye === true ?
                                        <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.ItemNo} style={{ width: "100px" }} /></td>
                                        :
                                        <Select
                                            isDisabled={itemData?.eye === true ? true : false}
                                            options={itemOptions}
                                            value={{ value: row.ItemNo, label: row.ItemNo }}
                                            onChange={selectedOption => handleInputChange(index, 'ItemNo', selectedOption.value)} />
                                    }
                                </td>
                                <td className='m-0 p-0'>
                                    {itemData?.eye === true ?
                                        <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.itemDescription} style={{ width: "120px" }} /></td>
                                        : <Select
                                            isDisabled={itemData?.eye === true ? true : false}
                                            options={descriptionOptions}
                                            value={{ value: row.itemDescription, label: row.itemDescription }}
                                            onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.value)}
                                        />}
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.specification} style={{ width: "120px" }}
                                    onChange={e => handleInputChange(index, 'specification', e.target.value)} disabled={itemData?.eye === true ? true : false} /></td>
                                <td className='m-0 p-0'><input className='p-2' onWheel={(e) => e.target.blur()} disabled={itemData?.eye === true ? true : false}
                                    type="number" value={row.qty} onKeyDown={preventNegativeSign}
                                    style={{ width: "90px" }} onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "140px" }} value={row.uom} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stock || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="number" onWheel={(e) => e.target.blur()} disabled={itemData?.eye === true ? true : false}
                                    value={row?.baseAmount} onKeyDown={preventNegativeSign}
                                    style={{ width: "120px" }} onChange={e => handleInputChange(index, 'baseAmount', e.target.value)} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.discount} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'>
                                    <Select className="flex-grow-1"
                                        theme={(theme) => ({
                                            ...theme,
                                            padding: 10
                                        })}
                                        value={{ value: row.vatDes, label: row.vatDes }}
                                        options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                                        onChange={selectedOption => handleInputChange(index, 'vat', selectedOption.value)} />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text"
                                    value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "120px" }} disabled type="text"
                                    value={(row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0)} /></td>
                                <input
                                    className='p-2' onWheel={(e) => e.target.blur()}
                                    type="number" style={{ width: "120px" }}
                                    value={row.batchNo}
                                    onKeyDown={preventNegativeSign}
                                    onChange={(e) => handleBatchNo(index, e.target.value)}
                                />
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} disabled={itemData?.eye === true ? true : false}
                                    onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>

                </table>
                <div className='d-flex gap-5'>
                    {itemData?.eye === true ? "" :
                        <button className='mainbtn  mt-4 gap-3' onClick={addNewRow}><IoAddSharp color='#fff' className='center mt-1 mx-2' /><div>Add</div>  </button>
                    }
                </div>
            </div>
            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{totalAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Vat</div>
                    <div className='field'>{totalVat?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Net Amount</div>
                    <div className='field'>{netAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default DirectPurchaseUpGrid;